// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bm7Od","content":"styles_content____m3w"};